export enum MensagemErroImportacaoWebISSEnum {

  contribuinteNaoEncontrado = "Contribuinte n�o encontrado",
  inscMunObrigatoria = "A Inscri��o Municipal � obrigat�ria",
  numNaoEncontrado = "N�mero n�o encontrado",
  serieNaoEncontrada = "S�rie n�o encontrada",
  exception = "Exception"
}
